'use client';

import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { COLORS } from '@/constants/colors';

interface Button1Props {
  text: string;
  handleClick?: () => void;
  marginTop?: number;
  isLink?: boolean;
  to?: string;
  target?: string;
  download?: boolean | string;
}

const Button1: React.FC<Button1Props> = ({
  text,
  handleClick,
  marginTop,
  isLink,
  to,
  target,
  download,
}) => {
  return isLink && to ? (
    <Link href={to} target={target} download={download || undefined}>
      <Button1Wrapper marginTop={marginTop}>{text}</Button1Wrapper>
    </Link>
  ) : (
    <Button1Wrapper onClick={handleClick} marginTop={marginTop}>
      {text}
    </Button1Wrapper>
  );
};

export default Button1;

const Button1Wrapper = styled.button<{ marginTop?: number }>`
  background-color: ${COLORS.brandGreenAccessible};
  background-image: none;
  min-width: 64px;
  color: #fff;
  padding: 6px 16px;
  border-radius: 4px;
  font-family: Lato, sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  border: none;
  cursor: pointer;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : 0)}px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #00901c;
  }

  a:hover {
    color: #fff;
  }
`;
